import React, { FunctionComponent } from "react";
import { Order } from "./model";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel, { TableSortLabelProps } from "@mui/material/TableSortLabel";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import BlueCheckbox from "../checkbox/checkbox";

type IListHeadProps = {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  headCells: any[];
  allChecked?: boolean;             
  onCheckAllChange?: (checked: boolean) => void;
};

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  "& th.MuiTableCell-head": {
    color: "var(--kyocera-text-grey) !important",
    whiteSpace: "nowrap",
    fontWeight: "bolder",

    "& span.visually-hidden": {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
  },
}));

export interface ISortableProps {
  sortable?: boolean;
}

const ListHeadComponent: FunctionComponent<IListHeadProps & ISortableProps> = (props) => {
  const { order, orderBy, onRequestSort, headCells, sortable, allChecked, onCheckAllChange } = props;
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };
  const { t } = useTranslation();

  const ListHeadCellWrapper: FunctionComponent<TableSortLabelProps & ISortableProps> = ({
    sortable,
    children,
    ...rest
  }) => {
    return sortable ? (
      <TableSortLabel {...rest}>{children}</TableSortLabel>
    ) : (
      <>{children}</>
    );
  };

  return (
    <StyledTableHead>
      <TableRow>
        {headCells.map((headCell) => {
          const cell = headCell.display ? (
            <TableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
              align={headCell.align ? headCell.align : "inherit"}
            >
              {headCell.id === "checkbox" ? (
                <BlueCheckbox
                  color="primary"
                  checked={allChecked}
                  onChange={(e) => {
                    if (onCheckAllChange) {
                        onCheckAllChange(e.target.checked); // Call callback with new checked state
                    }
                  }}
                />
              ) : (
                <ListHeadCellWrapper
                  sortable={sortable}
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {t(headCell.label)}
                  {orderBy === headCell.id ? (
                    <span className="visually-hidden">
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </ListHeadCellWrapper>
              )}
            </TableCell>
          ) : null;

          return cell;
        })}
      </TableRow>
    </StyledTableHead>
  );
};

export default ListHeadComponent;
